// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1gu1E","text":"SelectPayment_text__2xZmu","title":"SelectPayment_title__-FLb6","btn":"SelectPayment_btn__b1hSl"};